import React, { useEffect, useState } from "react";
import {
  Button,
  Heading,
  Loader,
  ScrollView,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  View,
  Icon,
  useAuthenticator,
  Flex,
  Text,
  ButtonColorTheme
} from "@aws-amplify/ui-react";
import "./Task.css";
import { format } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { updateTaskStatusAPI } from "../../data/api";
import emitter from "../../eventBus/EventBus";


const TaskCard = (props) => {
  const [task, setTask] = useState(props.task);
  const [taskTheme, setTaskTheme] = useState('normal');
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const setTaskCompletato = (completato) => {
    const newTask = {
        ...task,
        completato: completato,
    };
    updateTaskStatus(newTask)
  }

  const updateTaskStatus = async (newTask) => {
    try{
      setLoadingUpdate(true);
      props.onLoading !== undefined && props.onLoading(true);
      setError(false);
      await updateTaskStatusAPI(newTask.id, newTask.completato);
      setTask(newTask);
      setLoadingUpdate(false);
      emitter.emit('updatedTask');
      props.onLoading !== undefined && props.onLoading(false);
      props.onUpdate !== undefined && props.onUpdate(newTask);
    } catch (e) {
      console.log('Updating task failed ', e);
      setError(true);
      setLoadingUpdate(false);
      props.onLoading !== undefined && props.onLoading(false);
    }
  };

  useEffect(() => {
    const differenceInDays = ((new Date()).setHours(0, 0, 0, 0) - new Date(task.dataTask).setHours(0, 0, 0, 0)) / (1000 * 3600 * 24)
    if(differenceInDays >= 0 && !task.completato){
      setTaskTheme('error')
    } else if(differenceInDays >= -3 && !task.completato){
      setTaskTheme('warning')
    } else {
      setTaskTheme('normal')
    }
  }, [task])

  return (
    <View
        borderRadius="6px"
        maxWidth="100%"
        padding="1rem"
        width="100%"
        fontWeight="normal"
        display="block"        
        className={"amplify-button task-card-"+taskTheme}
        onClick={() => {
          const currentUrl = new URL(window.location.href);
          const newPath = new URL(task.link, currentUrl.origin);
          newPath.searchParams.append('task', task.id);
          navigate(newPath.pathname + newPath.search);
        }}
      >
        <Flex direction="row" gap="0.5rem" wrap="nowrap">
          <View flex="1 1 50%">
            {task.testo}
          </View>
          <View flex="1 1 10%">
            <Text fontWeight="bold" textAlign="center">{format(task.dataTask, 'dd/MM/yyyy')}</Text>
          </View>
          <View flex="1 1 20%">
            {task.operatori.join(', ')}
          </View>
          <View flex="1 1 20%">
              <Button 
                onClick={(e) => {e.stopPropagation(); setTaskCompletato(!task.completato)}}
                disabled={loadingUpdate || props.loading}
                width="100%"
                variation={task.completato ? undefined : "primary"}
                >{loadingUpdate ? <Loader/> : task.completato ? "Completato" : "Segna come completato"}</Button>
          </View>
        </Flex>
      </View> 
  );
};

export default TaskCard;
